import { forwardRef } from "react";
import styles from "../Login.module.css";
import { observer } from "mobx-react-lite";
import { authStore } from "@/stores/AuthStore";
import { FormProvider } from "react-hook-form";

import { Fields } from "./Fields";
import { ImageCaptcha } from "./ImageCaptcha";
import { Puzzles } from "./Puzzles";
import { useFormLogin } from "@/hooks/Login/useFormLogin";
import { useOnErrorWithNotifications } from "@/hooks/Utils/useOnErrorWithNotifications";
import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";

export const LoginBox = observer(
  forwardRef<HTMLFormElement>((_, ref) => {
    const { dataForm, onSubmit } = useFormLogin();
    const onError = useOnErrorWithNotifications();

    return (
      <FormProvider {...dataForm}>
        <form
          onSubmit={dataForm.handleSubmit(onSubmit, onError)}
          noValidate
          className={styles.form}
          ref={ref}
        >
          <div className={styles.loginBox}>
            <div className={styles.dotTop}></div>
            <h2 className={styles.h2}>Авторизация</h2>
            {authStore.isLoadingAuth && <div>Загрузка...</div>}
            <Fields />
            <ImageCaptcha />
            <span className={styles.span}>Введите символы с картинки</span>
            <Puzzles />
            <div className={styles.loginButton}>
              <TematicalColorButton type="submit">Войти</TematicalColorButton>
            </div>
            <div className={styles.boxError}>
              {/* Блок для отображения ВСЕХ ошибок */}
              {authStore.error}
            </div>
          </div>
        </form>
      </FormProvider>
    );
  }),
);
